import { RefObject, useCallback } from 'react';
import { getFocusableElements } from 'src/utils/html';

const INPUT_INDEX = 0;

export const useArrowNavigation = () =>
  useCallback(
    (
      { key, code }: React.KeyboardEvent<HTMLDivElement>,
      dialogRef: RefObject<HTMLElement | null>,
    ) => {
      const focusableElements = getFocusableElements(dialogRef.current);
      if (!focusableElements) {
        return;
      }

      const currentIndex = focusableElements.findIndex(
        (element) => element === document.activeElement,
      );
      let nextIndex = currentIndex;

      if (key === 'ArrowDown' || (key === 'ArrowRight' && currentIndex !== INPUT_INDEX)) {
        nextIndex = (currentIndex + 1) % focusableElements.length;
      } else if (key === 'ArrowUp' || (key === 'ArrowLeft' && currentIndex !== INPUT_INDEX)) {
        nextIndex = (currentIndex - 1) % focusableElements.length;
        nextIndex = nextIndex >= 0 ? nextIndex : focusableElements.length - 1;
      } else if (code === `Key${key.toUpperCase()}` || code === `Digit${key}`) {
        nextIndex = INPUT_INDEX;
      }

      if (currentIndex !== nextIndex) {
        focusableElements[nextIndex]?.focus();
      }
    },
    [],
  );
